<figure class="shape" [style.--shape-path]="shapePath" [style.--shape-image]="CSSImageUrl">
  <div class="shape__image" [ngClass]="shape" [attr.data-background-position]="anchor"></div>
  <fstr-icon class="shape__bg" [ngClass]="'icon-color-' + backgroundColor" [anchor]="shape"></fstr-icon>
</figure>
